import "./../../bindings/bao-toolbar2";
import "./../../bindings/bao-upload";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import TabPage from "./../../factories/tab-page";
import WorkItem from "../work-item";
import * as ko from "knockout";

/**
 * ViewModel for WorkItemObjectTab
 */
class WorkItemObjectTab extends GenericListSearchTab {

    // #region Constructor

    /** 
     *Constructor
     */
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);


        this.Models.subscribe(() => {
            this.Selection([]);
        });
    }

    //  #endregion

    // #region Properties

    /**
     * Controller Url 
     */
    ControllerUrl = "WorkItemObjectTab";

    /**
     * Access to parent WorkItem (the "parent" for series elements)
     */
    Parent: WorkItem;

    /**
     * Store the info if the WorkItem is a WorkItem Series 
     */
    InitBasedOnSerialTask: KnockoutObservable<boolean> = ko.observable(false);

    /**
     * Flag, which indicates if the view model is initialized
     */
    Initialized: KnockoutObservable<boolean> = ko.observable(false);

    // #endregion

    // #region Public Methods

    /**
     * Returns name of search type
     * @returns Name of search type
     */
    SearchType() {
        return "ConfigurationItemAll";
    }

    /**
     * Returns custom filters
     * @returns Custom filters
     */
    CustomFilter(): Models.HashObject[] {
        let customFilterHashObject: Models.HashObject[] = [];
        if (this.InitBasedOnSerialTask()) {
            customFilterHashObject.push({
                Key: 'WorkItemId',
                Value: this.Parent.PrimaryWorkItemId()
            });
            customFilterHashObject.push({
                Key: 'BaseOnSerialTask',
                Value: true
            });
        }
        return customFilterHashObject;
    }

    /**
     * Checks if the view model has been set correctly
     * @returns JqueryPromise<boolean>
     */
    ItemCompleteCheck(): JQueryPromise<boolean> {
        let def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }

    /**
     * Init
     */
    init = (): JQueryPromise<void> => {
        if (this.Parent.IsBasedOnVirtual()) {
            this.InitBasedOnSerialTask(true);
        }
        return super.init()
            .always(_ => {
                this.InitBasedOnSerialTask(false);
                this.Initialized(true);
            });
    }

    // #endregion

}
export default WorkItemObjectTab;